import '../style/style.scss';
import { A11yFixUrlCrawler } from './crawler/a11yfix-url-crawler';
import { CrawlerLayout } from './layout/crawler-layout';
import { LocalStorageService } from './services/local-storage-service';
import { EmptyOrUntitledLinksRule } from './rules/empty-or-untitled-links-rule';
import { AccessibleNamePreferredSourceRule } from './rules/accessible-name-preferred-source-rule';
import { AriaHiddenInteractiveRule } from './rules/aria-hidden-interactive-rule';
import { AriaLabelledbyIntegrityRule } from './rules/aria-labelledby-integrity-rule';
import { FormLabelsRule } from './rules/form-labels-rule';
import { HeadingOrderRule } from './rules/heading-order-rule';
import { ImageAltTextRule } from './rules/image-alt-text-rule';
import { KeyboardFocusableElementsRule } from './rules/keyboard-focusable-elements-rule';
import { LowColorContrastRule } from './rules/low-color-contrast-rule';
import { RuleRunner } from './rules/rule-runner';

const { __ } = window.wp.i18n;
const A11YFIX_TEXT_DOMAIN = 'a11yfix-for-wcag';
const translate = (text) => __(text, A11YFIX_TEXT_DOMAIN);

document.addEventListener('DOMContentLoaded', async () => {
	const localStorageService = new LocalStorageService('a11yfix_');
	const layout = new CrawlerLayout(translate);
	const rules = [
		new ImageAltTextRule(translate),
		new EmptyOrUntitledLinksRule(translate),
		new HeadingOrderRule(translate),
		new FormLabelsRule(translate),
		new AccessibleNamePreferredSourceRule(translate),
		new AriaLabelledbyIntegrityRule(translate),
		new AriaHiddenInteractiveRule(translate),
		new KeyboardFocusableElementsRule(translate),
		new LowColorContrastRule(translate)
	];
	const ruleRunner = new RuleRunner(rules, translate);
	const crawler = new A11yFixUrlCrawler(localStorageService, translate, layout, ruleRunner);
	try {
		await crawler.init();
	} catch (error) {
		console.error('A11yFix initialization error:', error);
	}
});
